exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.VueCharacterCounter{text-align:right;margin-top:10px\n}\n.VueCharacterCounter svg{width:20px;-webkit-transform:rotate(-90deg);transform:rotate(-90deg)\n}\n.fade-enter,.fade-leave-to{opacity:0\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"scoped":false,"sourceMap":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/js/components/CharacterCounter.vue
// module id = N5R5
// module chunks = 97